import React, { useMemo } from "react";
import cn from "classnames";
import { useBreakpoints } from "@evidenceb/athena-common/helpers/breakpoints";
import { Student } from "../../interfaces/Session";
import StudentChip, { CHIP_HEIGHT } from "../StudentChip/StudentChip";
import useTagTruncator from "../../hooks/useTagTruncator";
import { defineMessages, useIntl } from "react-intl";

import "./CondensedStudentsList.scss";

type Props = {
    students: Student[];
    className?: string;
};

const CondensedStudentsList = ({ students, className }: Props) => {
    const intl = useIntl();
    const { isTabletOrSmaller } = useBreakpoints();

    const truncatorOpts = useMemo(
        () => ({
            maxHeight: getMaxHeight(isTabletOrSmaller ? 1 : 3),
            deps: [students],
        }),
        [isTabletOrSmaller, students]
    );
    const { containerProps, isExtended, toggleExtend, hiddenCount } =
        useTagTruncator(truncatorOpts);

    return (
        <ul
            {...containerProps}
            style={{
                ...containerProps.style,
                // @ts-ignore
                "--tag-height": CHIP_HEIGHT,
            }}
            className={cn("condensed-students-list", className)}
        >
            {students.map((student) => (
                <li key={student.id}>
                    <StudentChip {...student} />
                </li>
            ))}

            {(isExtended || !!hiddenCount) && (
                <button
                    className="condensed-students-list__show-more"
                    onClick={toggleExtend}
                >
                    {isExtended
                        ? intl.formatMessage(messages.seeFewerStudents)
                        : `+${hiddenCount}`}
                </button>
            )}
        </ul>
    );
};
export default CondensedStudentsList;

const messages = defineMessages({
    seeFewerStudents: {
        id: "playlist-seeFewerStudents",
        defaultMessage: "See fewer students",
    },
});

const getMaxHeight = (numberOfLinesToShow: number) => {
    return `calc(${numberOfLinesToShow} * ${CHIP_HEIGHT} + ${
        numberOfLinesToShow - 1
    } * var(--gap) + var(--padding-bottom))`;
};
